module.exports = __webpack_public_path__ + "static/media/blogiconhover.57d5da9f.svg";